export default [
  {
    value: "goods",
    label: "商品",
    children: [
      {
        value: "goodsItem",
        label: "单个商品"
      },
      {
        value: "assemblyGoods",
        label: "组合商品"
      }
    ]
  },
  {
    value: "page",
    label: "页面",
    children: [
      {
        value: "home",
        label: "首页"
      },
      {
        value: "myCoupon",
        label: "我的优惠券"
      },
      {
        value: "shopCart",
        label: "购物车"
      },
      {
        value: "claimCenter",
        label: "领券中心"
      },
      {
        value: "shopList",
        label: "门店列表"
      },
      {
        value: "distributionPage",
        label: "分销活动页"
      },
      {
        value: "seckillPage",
        label: "限时秒杀页"
      }
    ]
  },
  {
    value: "type",
    label: "类目",
    children: [
      {
        value: "shopType",
        label: "商城类目"
      }
    ]
  },
  {
    value: "other",
    label: "其他",
    children: [
      {
        value: "otherUrl",
        label: "H5链接"
      },
      {
        value: "searchResultPage",
        label: "搜索结果页"
      }
    ]
  },
  {
    value: "science",
    label: "科普",
    children: [
      {
        value: "article",
        label: "文章"
      },
      {
        value: "video",
        label: "视频"
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/cascaderOptions.js